import React from "react";
import styled from "./Contact.module.css";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillPhone,
  AiFillMail,
} from "react-icons/ai";

const Contact = () => {
  return (
    <div id="contact" className={styled.section}>
      <h2 className={styled.heading}>
        <span className={styled.accent}>Contact</span> Me
      </h2>
      <p className={styled.subtitle}>
        Have a project in mind or an ERP system to build? I'd love to hear
        about it.
      </p>

      <div className={styled.card}>
        <a className={styled.row} href="mailto:miftahulislam.dev@gmail.com">
          <AiFillMail className={styled.icon} />
          <span>miftahulislam.dev@gmail.com</span>
        </a>
        <a className={styled.row} href="tel:+971545267087">
          <AiFillPhone className={styled.icon} />
          <span>+971 54 526 7087</span>
        </a>
      </div>

      <div className={styled.social}>
        <a
          className={styled.iconLink}
          target="_blank"
          rel="noreferrer"
          href="https://github.com/itzmiftah"
          aria-label="GitHub"
        >
          <AiFillGithub className={styled.socialIcon} />
        </a>
        <a
          className={styled.iconLink}
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/miftahul-islam-b794a817a/"
          aria-label="LinkedIn"
        >
          <AiFillLinkedin className={styled.socialIcon} />
        </a>
      </div>

      <p className={styled.footer}>
        © {new Date().getFullYear()} Md Miftahul Islam. All rights reserved.
      </p>
    </div>
  );
};

export default Contact;
